import React, { useContext, useEffect, useState } from 'react';
import { IProps } from './types';
import * as S from './styles';
import { ICommonAttributes } from 'routes/private/Editor/types';
import { Context } from "routes/private/Editor/Context";
import { findElementById } from "@utils/editor";
import { CopyPasteIcon } from '@assets/icons/copyPasteIcon';
import Tooltip from '@components/Tooltip';

const CopyPasteCommandOption : React.FC<IProps> = () => {
  let { onCommandChange} = useContext(Context);

  return (    
    <S.Root>
      <Tooltip tip={"Copy/Paste"}>
        <S.ButtonContainer onClick={()=> { onCommandChange("copypaste", {copy: true, paste: true}) }}>
          <CopyPasteIcon/>
        </S.ButtonContainer>
      </Tooltip>
    </S.Root>
  );
}

export default CopyPasteCommandOption;